import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { selectors as instancesSelectors } from 'dux/instances';
import InstanceItem from './InstanceItem';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
  getTotalSpace: instancesSelectors.getInstanceTotalSpace(state),
  getRedisMemoryCapacity: instancesSelectors.getRedisMemoryCapacity(state),
  getUnusedCockroachDBRegions: instancesSelectors.getUnusedCockroachDBRegions(state),
});

export default connect(mapStateToProps, null)(InstanceItem);
